import React from 'react';
import getConfig from 'next/config';

import {Tenant} from '~/src/utilities/constants/tenant';

import css from '~/src/css/global.module.scss';

const {publicRuntimeConfig: config} = getConfig();

const ShareFacebook = ({title}) => (
    <svg viewBox="0 0 11 22">
        {title && <title>{title}</title>}
        <g id="Front-Desktop" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g
                id="Front-Desktop_share"
                transform="translate(-775.000000, -740.000000)"
                fill={config.tenantId === Tenant.LEMATIN ? css.colorTango : css.accentColor}
            >
                <g id="Group-2" transform="translate(0.000000, -7.000000)">
                    <g id="Group-7" transform="translate(747.000000, 252.000000)">
                        <g id="Facebook" transform="translate(0.000000, 471.000000)">
                            <path d="M35.1522634,46 L35.1522634,35.9580273 L38.3888889,35.9580273 L38.8641975,32.0566632 L35.1522634,32.0566632 L35.1522634,29.5403987 C35.1522634,28.9863561 35.265431,28.5323557 35.4917695,28.1783841 C35.7181081,27.8244124 36.22359,27.6474292 37.0082305,27.6474292 L39,27.6474292 L39,24.13851 C38.8340184,24.1231199 38.4794266,24.0961877 37.936214,24.0577125 C37.3930014,24.0192373 36.7818964,24 36.1028807,24 C35.3785972,24 34.7184529,24.1115764 34.122428,24.3347324 C33.5264031,24.5578885 33.0171489,24.8887701 32.5946502,25.3273872 C32.1721515,25.7660043 31.8401933,26.3046488 31.5987654,26.9433368 C31.3573376,27.5820249 31.2366255,28.3245848 31.2366255,29.1710388 L31.2366255,32.0566632 L28,32.0566632 L28,35.9580273 L31.2592593,35.9580273 L31.2592593,46 L35.1522634,46 Z"></path>
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </svg>
);

export default ShareFacebook;
